<script setup lang="ts">
import { computed } from 'vue'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useSignupStorage } from '@/composables/useSignupStorage'

const { signup } = useSignupStorage()

const fallbackOptions = [
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Bi-Weekly', label: 'Bi-Weekly' },
  { value: 'Monthly', label: 'Monthly' },
]

const frequencyOptions = computed(() =>
  signup.available_frequencies.length > 0
    ? signup.available_frequencies
    : fallbackOptions
)
</script>

<template>
  <div>
    <div class="space-y-2 mb-8">
      <label class="text-xs font-bold uppercase tracking-[1.4px] text-mm-dark">
        Choose your mow frequency<span class="text-mm-green">*</span>
      </label>
      <Select v-model="signup.frequency">
        <SelectTrigger class="h-12 data-[state=open]:border-mm-green focus-visible:border-mm-green focus-visible:ring-mm-green/30">
          <SelectValue placeholder="Select frequency" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem
            v-for="option in frequencyOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  </div>
</template>
